import { decode } from 'base-64'
import { jwtDecode } from 'jwt-decode'

import type { TTokenPayload } from '../models/auth.types'

global.atob = decode

/**
 * @returns the payload inside a JWT token, false if payload cannot be read
 * We use a try/catch because the jwtDecode function throws an exception.
 * Attention: a JWT can be invalid on the server-side and still be decoded correctly,
 * because only the last part of the token is the actual signature (see www.jwt.io)
 */
export function decodeToken(token?: string | null): TTokenPayload | null {
  if (!token) return null
  try {
    return jwtDecode(token)
  } catch (_) {
    return null
  }
}
